import React from "react";
import "./StudyLayout.css";

const StudyLayout = ({ children, breadcrumbs, buttons, hideNavigation, className }) => {
  return (
    <div className={`study-layout${className ? ` ${className}` : ``}`}>
      {!hideNavigation && breadcrumbs && (
        <div className="study-layout-breadcrumbs-fixed">
          {breadcrumbs}
        </div>
      )}
      
      {!hideNavigation && buttons && (
        <div className="study-layout-buttons-fixed">
          {buttons}
        </div>
      )}
      
      <div className="study-layout-content-scrollable">
        {children}
      </div>
    </div>
  );
};

export default StudyLayout;
